<template>
  <div class="title">
    <!-- <div class="title-text">患者档案</div> -->
    <div class="left">
      <div class="title-text">患者档案</div>
      <a-tabs class="tabs" v-model:activeKey="activePatientId" @change="changeTab">
        <a-tab-pane
          v-for="item in patientFileDictionary"
          :key="item.key"
          :tab="item?.value?.name ? maskName(item.value.name) : `患者-${item?.value?.patientId}`"
        ></a-tab-pane>
      </a-tabs>
    </div>
    <div class="right">
      <!--      <div class="buttons">-->
      <!--        <a-button @click="openMatch" type="primary">匹配关联已有用户</a-button>-->
      <!--      </div>-->
      <header-info-title class="options" />
      <div class="small" @click="onSmall">
        <small-icon />
      </div>
    </div>
    <a-modal
      okText="匹配用户"
      @ok="confirmSave"
      @cancel="cancel"
      v-model:visible="visible"
      title="匹配合并已有用户"
      :okButtonProps="{
        disabled: !hasMatch
      }"
    >
      <div class="modal">
        <span class="label">搜索用户：</span>
        <!-- <a-auto-complete class="item_component" v-model:value="name" @search="handleSearch">
          <template #default>
            <a-input-search
              :maxlength="50"
              placeholder="输人手机号码/姓名搜索用户"
              v-model:value="name"
              size="large"
            ></a-input-search>
          </template>
          <template #options>
            <a-select-option
              v-for="patient in patients"
              :key="`${patient.patientId}`"
              @click="checkPatient(patient)"
              class="auto-complete_item"
            >
              <div class="content">
                <span class="item">
                  <div v-html="patient._name"></div>
                </span>
                <span class="item">
                  {{ patient.gender ? '男' : '女' }}
                </span>
                <span class="item">{{ patient.age || '--' }}岁</span>
              </div>
              <div class="tips">{{ patient.phone }}</div>
            </a-select-option>
          </template>
        </a-auto-complete> -->
        <a-select
          v-model:value="name"
          class="item_component"
          show-search
          placeholder="输人手机号码/姓名搜索用户"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @select="handleSelect"
        >
          <template #suffixIcon>
            <search-outlined />
          </template>
          <a-select-option
            v-for="patient in patients"
            :key="patient.patientId"
            :value="patient.patientId"
            class="auto-complete_item"
          >
            <div class="content">
              <span class="item">
                <div v-html="patient._name"></div>
              </span>
              <span class="item">
                {{ patient.gender ? '男' : '女' }}
              </span>
              <span class="item">{{ patient.age || '--' }}岁</span>
            </div>
            <div class="tips">{{ patient.phone }}</div>
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { getPatientName, patientPhoneRel } from '@/api/patientFile'
import { debounce, maskName } from '@/utils'
import { ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import { computed, createVNode, nextTick, ref } from 'vue'
import { useStore } from 'vuex'
import HeaderInfoTitle from './ModalBody/top/HeaderInfoTitle.vue'
import SmallIcon from '@/assets/svg/SmallIcon.vue'
const store = useStore()
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)
const patientFileDictionary = computed(() => store.state.patientFile.dictionary)
const activePatientId = computed(() => store.state.patientFile.activePatientId)
const onSmall = () => {
  store.commit('patientFile/SET_STATE', 2)
}
const visible = ref(false)
const name = ref(undefined)
const patients = ref([])
const openMatch = () => {
  visible.value = true
}
const cancel = () => {
  visible.value = false
  match.value = {}
  name.value = ''
}
// 有匹配的患者
const hasMatch = computed(() => match.value.patientId || match.value.prePatientId)
const save = () => {
  if (!hasMatch.value) return message.warn('请选择关联患者')
  const params = {
    patientId: patientType.value ? info.value.patientId : info.value.prePatientId,
    patientType: patientType.value,
    matchPatientId: match.value.patientId, // match.value.patientType ? match.value.patientId : match.value.prePatientId,
    matchPatientType: match.value.patientType
  }
  patientPhoneRel(params).then(async result => {
    if (result) {
      message.success('关联成功')
      cancel()
      const { patientType, patientId } = result
      const _params = {
        patientType,
        patientId
      }
      store.commit('patientFile/SET_LOADING', true)
      await store.dispatch('patientFile/getInfo', _params)
      store.commit('patientFile/UPDATE_DICCTIONARY', {
        prePatientId: params.patientId,
        matchPatientInfo: _params
      })
      await store.dispatch('patientFile/getRemark')
      await store.dispatch('patientFile/getStage')
      store.commit('patientFile/SET_LOADING', false)
    } else {
      message.warn('该用户已实名，无法关联匹配！')
    }
  })
}
// 二次确认
const confirmSave = () => {
  const left = `确认将【患者-${info.value.name},${info.value.phone || ''}】,`
  const right = `关联【${match.value.name}${match.value.phone ? '-' + match.value.phone : ''}】，`
  Modal.confirm({
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: left + right + '关联后将共用档案。',
    onOk() {
      save()
    },
    onCancel() {}
  })
}
// 防抖
const handleSearch = debounce(val => {
  patients.value = []
  if (!val) return
  const params = { name: val }
  getPatientName(params)
    .then(result => {
      const arr = result
        // 过滤掉相同的患者ID
        .filter(f => {
          let ans = false
          if (f.patientType) {
            ans = f.patientId !== info.value.patientId
          } else {
            ans = f.patientId !== info.value.prePatientId
          }
          return ans
        })
        .map(item => {
          const { name } = item || {}
          // 将结果中的机构名称中的搜索关键词进行高亮处理
          const regExp = new RegExp(val, 'g')
          item._name = name.replace(regExp, `<span style="color: #1890FF">${val}</span>`)
          return item
        })

      nextTick(() => {
        patients.value = arr
      })
    })
    .catch(err => {})
}, 500)
// 选中某一个关联患者
const match = ref({})
const handleSelect = value => {
  match.value = patients.value.find(v => v.patientId === value) || {}
}
// 切换患者档案
const changeTab = key => {
  // 处理key为null或undefined的情况
  if (!key) return
  const val = patientFileDictionary.value.find(f => f.key === key)
  // 确保找到对应项后再调用store方法
  if (val) {
    store.dispatch('patientFile/changeTab', val.value)
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 32px);
  align-items: center;
  height: 100%;
  overflow: hidden;
  .left {
    flex-grow: 1;
    margin-right: 20px;
    display: flex;
    align-items: center;
    width: calc(100% - 360px);
    .title-text {
      font-size: 14px;
      color: #000000d9;
      border-right: 1px solid #d9e1e7;
      padding-right: 20px;
      margin-right: 20px;
      height: 100%;
      width: 77px;
      flex-shrink: 0;
    }
    ::v-deep(.tabs) {
      flex-grow: 1;
      width: calc(100% - 77px);
      .ant-tabs-bar {
        border-bottom: 1px solid transparent;
        margin-bottom: 0;
        .ant-tabs-tab {
          padding: 12px 0;
        }
        .ant-tabs-tab-active {
          font-weight: 500;
          text-shadow: none;
        }
      }
    }
  }
  .right {
    display: flex;
    flex-shrink: 0;
    width: calc(56px + 280px);
    height: 100%;
    .options {
      margin-right: 12px;
    }
    .small {
      width: 56px;
      cursor: pointer;
      text-align: center;
      height: 56px;
      line-height: 56px;
      color: #999;
      &:hover {
        color: #333;
      }
    }
  }
}
.modal {
  .label {
    width: 80px;
  }
  .item_component {
    width: calc(100% - 80px);
  }
}
.auto-complete_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px;
  padding: 10px 16px;
  .content {
    margin-bottom: 8px;
    .item {
      display: inline-block;
      margin-right: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }
  .tips {
    font-size: 14px;
    color: #999999;
  }
}
</style>
